import { getPermissionsFlags } from "shared/roles";
import useUserRoles from "../../../hooks/use-user-roles";
import { PermissionResource } from "../../../generated/graphql";

export type UseIsInternalAdminResult = {
  loading: boolean;
  canAccess: boolean;
};

/**
 * Permission gate for the API key management admin tool.
 *
 * Grants access when the signed-in user holds write access on either
 * `INTERNAL_TOOLS` or the catch-all `MASTER` permission resource. Mirrors the
 * backend `InternalToolsGuard` applied via the `@InternalTools()` decorator on
 * `ApiKeysAdminResolver`.
 *
 * @returns `loading` while the user's roles are being fetched and `canAccess`
 * once the resolved permissions have been evaluated.
 */
const useIsInternalAdmin = (): UseIsInternalAdminResult => {
  const { userPermissions, userRolesLoading } = useUserRoles();
  const { canWrite, hasMasterPermission } = getPermissionsFlags(
    userPermissions,
    PermissionResource.InternalTools,
  );
  return {
    loading: userRolesLoading,
    canAccess: canWrite || hasMasterPermission,
  };
};

export default useIsInternalAdmin;
